Bingo.MortgageCalculator = {
    years: $('#js-mortgageCalculator--years'),
    amount: $('#js-mortgageCalculator--amount'),
    personalContribution: $('#js-mortgageCalculator--personalContribution'),
    nominalRate: $('#js-mortgageCalculator--nominalRate'),
    yearsText: $('#js-mortgageCalculator__summaryYears'),
    priceMonthText: $('#js-mortgageCalculator__summaryPrice'),
    submit: $('#js-mortgageCalculator__submit, .js-mortgageCalculator__submit'),
    init() {
        this.years.slider();

        if ($('.O-mortgageCalculator').length) {
            Bingo.AutoNumeric.init('#js-mortgageCalculator--amount, #js-mortgageCalculator--personalContribution, #js-mortgageCalculator--nominalRate', {
                decimalCharacter: '.',
                digitGroupSeparator: ' ',
                decimalPlacesOverride: '0',
                minimumValue: '0.00',
            });
            this.mortgageCalculations();
            $(window).resize(() => {
                this.mortgageCalculations();
            });
        }

        this.years.on('slide change slideStart slideStop', () => {
            this.mortgageCalculations();
        });

        this.personalContribution.change(() => {
            this.mortgageCalculations();
        });

        this.nominalRate.change(() => {
            this.mortgageCalculations();
        });

        this.amount.change(() => {
            this.personalContribution.val(0);
            this.mortgageCalculations();
        });
    },
    getMonthlyPayment(capital, duration, annualRate) {
        capital = 1000 * Math.round(capital / 1000);
        const M = 12;
        const K = 12;
        const iRate = annualRate / 100;
        const interm1 = M / K + ((M - K) / (2 * K * K)) * iRate;
        const interm2 = (1 + (iRate / K)) ** duration;
        const interm3 = 1 - (1 / interm2);
        const interm4 = (interm3 / (iRate / K));

        return Math.round(capital / (interm1 * interm4) * 100) / 100;
    },
    mortgageCalculations() {
        let personalContribution = parseInt(this.personalContribution.val());
        const offerPrice = parseInt(this.amount.val());
        if (personalContribution > offerPrice) {
            //  Bingo.AutoNumeric.setVal(this.personalContribution, 0);
            return false;
        }
        const offerPriceWithoutPersonalContribution = offerPrice - personalContribution;
        //  Bingo.AutoNumeric.setVal(this.amount, offerPriceWithoutPersonalContribution);
        const durationYears = parseInt(this.years.slider('getValue'));
        const durationMonths = durationYears * 12;
        const annualRate = Math.round(this.nominalRate.val() * 10) / 10;
        personalContribution = parseInt(this.personalContribution.val());
        const monthlyPayment = parseInt(this.getMonthlyPayment(offerPriceWithoutPersonalContribution, durationMonths, annualRate));
        this.yearsText.text(durationYears);
        this.priceMonthText.text(monthlyPayment);
        return true;
    },
};
